// const Development = 'http://127.0.0.1:8080/api/v1/';
const Production = 'https://salty-atoll-87762.herokuapp.com/api/v1/';

const BaseUrl = Production;

export default BaseUrl;
